// extracted by mini-css-extract-plugin
module.exports =  {"duplicateRoadmapPortal":"OnS3tsEQ","modalContent":"qUbYaUa0","label":"QJG4ppjd","smallLabel":"SYY4JHNz"};